import antdEnUS from 'ant-design-vue/es/locale-provider/en_US'
import momentEU from 'moment/locale/eu'
import Index from './en-US/index'


const components = {
  antLocale: antdEnUS,
  momentName: 'eu',
  momentLocale: momentEU
}

export default {
  message: '-',
  ...components,
  ...Index
}



// WEBPACK FOOTER //
// ./src/locales/lang/en-US.js